import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2026 from '../CoScholacticSidebar2026/CoScholacticSidebar2026';




const FieldTripClass11and122026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip11&12/1.webp`;
const p2 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip11&12/2.webp`;
const p3 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip11&12/3.webp`;
const p4 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip11&12/4.webp`;
const p5 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip11&12/5.webp`;

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},




  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      FIELD TRIP CLASS 11 & 12
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 11 & 12	    Date: 23 September 2026

        </Typography>
        

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
Students of Classes 11 and 12 of National Public School, Yeshwanthpur, embarked on an exciting and memorable field trip to Wonderla Amusement Park, Bangalore on Wednesday, 23 September 2026. The outing provided the students with an opportunity to take a break from their regular academic routine and enjoy a 
day of recreation, interaction and shared experiences with their peers and teachers.
     <br></br>
The day began with great enthusiasm as students explored the various attractions and rides at the amusement park. From thrilling rides that sparked excitement to enjoyable recreational activities, the students enthusiastically participated in the experiences offered at the park. 
The trip provided a refreshing blend of fun, adventure and relaxation.      
  <br></br>
The field trip concluded on a cheerful note, with students returning with wonderful memories and stories to share. The experience offered a refreshing break from scholastic pursuits while reinforcing the importance
 of friendship, cooperation and learning through shared experiences.
  <br></br>

        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
“The best memories are made when we step outside the classroom and experience life together.”
<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 350 : 550}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FieldTripClass11and122026;